import * as React from 'react'
import { Table, Icon, Popconfirm, Tooltip } from "antd";
import { ColumnProps } from 'antd/es/table';
import _ from "lodash";
// 静态URL
import { EUrl, orderDetailUrl } from "utils/enum/url";
// import { Form, Row, Col, Input, Button, Icon } from 'antd';
// 通用表格
// import CommonTable from "../widget/commonTable";
// 重写input
import "styles/customOrderInputTable.scss";

interface CustomOrder {
  skuName: string,
  orderState: string,
  goTime: string;

}

class CustomOrderTable extends Table<CustomOrder> {
}
class CustomOrderInputTable extends React.Component<any, any> {

  constructor(params) {
    super(params);
    this.state = {
      loading: false
    }
  }

  columns: ColumnProps<CustomOrder>[] = [
    {
      title: 'SKU名称',
      dataIndex: 'skuName',
      align: 'center',
      width: 240,

    },
    {
      title: '订单状态',
      dataIndex: 'orderState',
      align: 'center',
      render: (text: any, record: any, index: number) => {
        if(record.erro_info){
          return (
            <Tooltip title={record.erro_info}>
              <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center',}}>
                <Icon type="exclamation-circle" theme="filled" style={{color: 'red', fontSize: 14, paddingRight: 10}}/>
                {text}
              </div>
            </Tooltip>
          )
        }else{
          return (
            <div style={{ padding: 8 }}>
              {
                record.order_id ? 
                  <a
                  className="list-link"
                  href={orderDetailUrl(EUrl.orderDetail, record.order_id)}
                  target="_blank"
                  >
                    {text}
                  </a> : text
              }
            </div>
          );
        }
      }
    },
    {
      title: '出发日期',
      dataIndex: 'goTime',
      align: 'center',
    },
    {
      title: '数/成/儿/婴',
      dataIndex: 'numbers',
      align: 'center',
    },
    {
      title: '实付金额',
      dataIndex: 'payment',
      align: 'center',
    },
    {
      title: '订单成本',
      dataIndex: 'cost',
      align: 'center',
    },
    {
      title: '退款金额',
      dataIndex: 'amount',
      align: 'center',
    },
    {
      title: '订单毛利润',
      dataIndex: 'gross_profit',
      align: 'center',
    },
    {
      title: '供应商',
      dataIndex: 'supplier',
      align: 'center',
    },
    {
      title: '操作',
      align: 'center',
      render: (text: any, record: any, index: number) => {
        if(record.is_create == 1){
          return null
        }else{
          return (
            <div className={'customOrderTableAction'}>
              <Popconfirm
                title="您确认要删除本条sku订单吗？"
                onConfirm={() => {
                  this.delConfirm(record)
                }}
                okText="确认删除"
                cancelText="我再想想"
              >
                <Icon type="delete" theme="twoTone" style={{ fontSize: '16px' }}/>
              </Popconfirm>
              &nbsp;&nbsp;
              <Icon type="edit" theme="twoTone" style={{ fontSize: '16px' }} onClick={()=>{
                this.editRow(record);
              }}/>
            </div>
          )
        }
      },
    },
  ];

  delConfirm = (record) => {
    this.props.delTableRow(record);
  }

  editRow = (record) => {
    this.props.editTableRow(record).then(()=>{
      this.props._setFormByEdit(record);
    });
  }

  handleTableChange = () => {

  }

  _getOrderStateText = (orderState:any) => {
    if(orderState){
      return orderState;
    }else{
      return '-';
    }
    
  }

  _getNumbers = (num:any, adult_num:any, children_num:any, baby_num:any) => {
    if(!num) num = 0
    if(!adult_num) adult_num = 0
    if(!children_num) children_num = 0
    if(!baby_num) baby_num = 0
    return `${num}/${adult_num}/${children_num}/${baby_num}`
  }

  _calProfit = (payment, cost, amount) => {
    return payment - cost - amount
  }

  _getSkuName = (skuid) => {
    let skuName = '';
    if(skuid && this.props.skuList && this.props.skuList.length){
      _.forEach(this.props.skuList, (element) => {
        if(skuid == element.sku_id){
          skuName = element.name;
        }
      })
    }
    return skuName;
  }
  


  displayOrderList = (orderList:any) => {
    let displayOrderList:any = [];
    if(orderList && orderList.length){
      _.forEach(orderList, (element) => {
        displayOrderList.push({
          id: element.id,
          sku_id: element.sku_id,
          skuName: element.sku_name ? element.sku_name : this._getSkuName(element.sku_id),
          orderState: this._getOrderStateText(element.order_status),
          goTime: element.go_time,
          numbers: this._getNumbers(element.num, element.adult_num, element.children_num, element.baby_num),
          payment: Number(element.payment).toFixed(2),
          cost: Number(element.change_cost ? element.change_cost : element.cost).toFixed(2),
          amount: Number(element.amount ? element.amount : 0).toFixed(2),
          gross_profit: this._calProfit(element.payment, element.change_cost ? element.change_cost : element.cost, element.amount ? element.amount : 0).toFixed(2),
          supplier: element.supplier,
          uuid: element.uuid,
          is_create: element.is_create,
          erro_info: element.erro_info,
          order_id: element.order_id,
        })
      });
    }
    return displayOrderList
  }

  getTotalOrders = () => {
    return this.props.orderList ? this.props.orderList.length : 0
  }

  getTotalPayment = () => {
    let totalPayment:number = 0;
    _.forEach(this.props.orderList, (element) => {
      totalPayment = _.add(Number(element.payment ? element.payment : 0), totalPayment)
    })
    return totalPayment;
  }

  getTotalCost = () => {
    let totalCost:number = 0;
    _.forEach(this.props.orderList, (element) => {
      totalCost = _.add(Number(element.change_cost ? element.change_cost : element.cost ? element.cost : 0), totalCost)
    })
    return totalCost;
  }

  getTotalAmount = () => {
    let totalAmount:number = 0;
    _.forEach(this.props.orderList, (element) => {
      totalAmount = _.add(Number(element.amount ? element.amount : 0), totalAmount)
    })
    return totalAmount;
  }
  /**
   * 毛利润=实际付款-成本-退款
   */
  getGrossProfitMargin = () => {
    return this.getTotalPayment() - this.getTotalCost() - this.getTotalAmount();
  }

  render(){
    return(
      <div className={'customOrderTableContainer'} >
        <div className="customOrderInputFormTitle">
            <Icon type="snippets" />
            定制行程信息
        </div>
        <CustomOrderTable
          bordered
          columns={this.columns}
          // dataSource={this.props.orders}
          dataSource={this.displayOrderList(this.props.orderList)}
          // pagination={this.state.pagination}
          loading={this.state.loading}
          onChange={this.handleTableChange}
          scroll={{ x: 1300 }}
          pagination={false}
        />
        <div className="customOrderInputFormBottomTitle">
        订单数: {this.getTotalOrders()} 实付总金额: {this.getTotalPayment().toFixed(2)} 成本总金额: {this.getTotalCost().toFixed(2)} 退款总金额: {this.getTotalAmount().toFixed(2)} 毛利润总金额: {this.getGrossProfitMargin().toFixed(2)}
        </div>
      </div>
    )
  }
}
export default CustomOrderInputTable;
